<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>电梯管理</a-breadcrumb-item>
				<a-breadcrumb-item>电梯列表</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiElevatorQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="条件查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">电梯名称：</div>
						<a-input v-model="query.elevatorName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiElevatorQueryList">查询</a-button>
					<a-button icon="redo" @click="resetChange" style="margin-left: 14px;">重置</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="elevatorId" :loading="tableLoading" :pagination="false">
				<span slot="elevatorName" slot-scope="elevatorName">
					<a-button type="link" @click="edit(elevatorName)" >{{elevatorName.elevatorName}}</a-button>
				</span>
				<span slot="elevatorState" slot-scope="elevatorState">
					<a-tag v-if="elevatorState == 3" color="green">启用</a-tag>
					<a-tag v-if="elevatorState == 2" color="red">禁用</a-tag>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->		
		<a-modal title="添加" width="60%" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="电梯名称" has-feedback prop="elevatorName">
					<a-input v-model="addForm.elevatorName" placeholder="请输入电梯名称" />
				</a-form-model-item>
				<a-form-model-item label="电梯编号" has-feedback prop="elevatorNb">
					<a-input-search v-model="addForm.elevatorNb" style="width: 300px;" placeholder="请选择电梯编号" @search="findNewElevator(2)" enter-button="编号查询"/>
				</a-form-model-item>
				<a-form-model-item label="有效楼层" has-feedback prop="elevatorStorey">
					<a-textarea v-model="addForm.elevatorStorey" placeholder="Controlled autosize" :auto-size="{ minRows: 3, maxRows: 5 }" @change="elevatorStoreyChange('add')"/>
				</a-form-model-item>
				<a-form-model-item label="楼层展示" has-feedback prop="staffAccount">
					<a-tag v-for="(item, index) in addForm.elevatorStoreyList" :key="index">{{item}}</a-tag>
				</a-form-model-item>
				<a-form-model-item label="排序" has-feedback prop="elevatorSort">
					<a-input v-model="addForm.elevatorSort" style="width: 300px;" placeholder="从大到小排序" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="elevatorState">
					<a-radio-group name="elevatorState" v-model="addForm.elevatorState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="60%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="电梯名称" has-feedback prop="elevatorName">
					<a-input v-model="editForm.elevatorName" placeholder="请输入电梯名称" />
				</a-form-model-item>
				<a-form-model-item label="电梯编号" has-feedback prop="elevatorNb">
					<a-input-search v-model="editForm.elevatorNb" style="width: 300px;" placeholder="请选择电梯编号" @search="findNewElevator(3)" enter-button="编号查询"/>
				</a-form-model-item>
				<a-form-model-item label="有效楼层" has-feedback prop="elevatorStorey">
					<a-textarea v-model="editForm.elevatorStorey" placeholder="Controlled autosize" :auto-size="{ minRows: 3, maxRows: 5 }" @change="elevatorStoreyChange('edit')"/>
				</a-form-model-item>
				<a-form-model-item label="楼层展示" has-feedback prop="staffAccount">
					<a-tag v-for="(item, index) in editForm.elevatorStoreyList" :key="index">{{item}}</a-tag>
				</a-form-model-item>
				<a-form-model-item label="排序" has-feedback prop="elevatorSort">
					<a-input v-model="editForm.elevatorSort" style="width: 300px;" placeholder="从大到小排序" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="elevatorState">
					<a-radio-group name="elevatorState" v-model="editForm.elevatorState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 编号查询 -->
		<a-modal title="编号查询" width="40%" :visible="newVisible"  @cancel="newVisible = false"  :maskClosable="false" :keyboard="false" :footer="null">
			<a-table  :columns="newtableColumns" :data-source="newData" row-key="channelId" :pagination="false">
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="selectNewClick(tableAction)" >选择</a-button>
				</span>
			</a-table>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					elevatorName: '',
				},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'elevatorId', key:'elevatorId', align:'center'},
					{ title:'电梯名称', key:'elevatorName', align:'center', scopedSlots:{customRender:'elevatorName'}},
					{ title:'电梯编号', dataIndex:'elevatorNb', key:'elevatorNb', align:'center'},
					{ title:'楼层', dataIndex:'elevatorStorey', key:'elevatorStorey', align:'center'},
					{ title:'排序', dataIndex:'elevatorSort', key:'elevatorSort', align:'center', width:50},
					{ title:'状态', dataIndex:'elevatorState', key:'elevatorState', align:'center', scopedSlots:{customRender:'elevatorState'}},
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					elevatorName: '',
					elevatorStorey: '',
					elevatorState: 3,
					elevatorNb: '',
					elevatorStoreyList: [],
					elevatorSort: 0
				},
				addRules: {
					elevatorName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
					elevatorState: [{ required: true, message: '请选择', trigger: 'blur' }],
					elevatorSort: [{ required: true, message: '请输入', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					elevatorId: '',
					elevatorName: '',
					elevatorStorey: '',
					elevatorState: 3,
					elevatorNb: '',
					elevatorStoreyList: [],
					elevatorSort: 0
				},
				// 修改弹窗-end
				newVisible: false,
				newType: 2,
				newtableColumns: [
					{ title:'连接ID', dataIndex:'channelId', key:'channelId', align:'center'},
					{ title:'电梯编号', dataIndex:'elevatorNb', key:'elevatorNb', align:'center'},
					{ title: '操作', key: 'tableAction', align: 'center', scopedSlots: { customRender: 'tableAction' } },
				],
				newData: [],
				
			};
		},
		methods: {
			//选择弹窗
			// elevatoronChange() {
			// 	console.log(this.validElevator)
			// },
			//重置
			resetChange() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					elevatorName: '',
				}
			},
			//表格开始-搜索
			async apiElevatorQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiElevatorQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiElevatorQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiElevatorQueryList()
			},
			async apiElevatorAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiElevatorAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiElevatorQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiElevatorAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				this.editForm = items
				this.editForm.elevatorStoreyList = this.editForm.elevatorStorey.split(",")
				this.editVisible = true
				console.log(this.editForm);
			},
			async apiElevatorEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiElevatorEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiElevatorQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiElevatorEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.elevatorId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.elevatorName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiElevatorDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiElevatorDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiElevatorDel, {elevatorId: this.tableSelectedRows.elevatorId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiElevatorQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.elevatorId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			//查找未绑定的新电梯
			findNewElevator(type) {
				this.apiElevatorGetNew()
				this.newVisible = true
				this.newType = type
				
			},
			//获取未绑定的电梯编号
			async apiElevatorGetNew() {
				this.newData = []
				const {
					data: res
				} = await this.$http.post(this.navigation.apiElevatorGetNew, {elevatorId:""});
				if (res.code == 200) {
					// this.newData = res.data
					for(let v in res.data) {
						// console.log(res.data[v]);
						this.newData.push(res.data[v])
						
					}
					
				} else {
					this.$message.error(res.msg)
				}
			},
			selectNewClick(item) {
				if (this.newType == 2) this.addForm.elevatorNb = item.elevatorNb
				if (this.newType == 3) this.editForm.elevatorNb = item.elevatorNb
				this.newVisible = false
			},
			//楼层输入变化时() 
			elevatorStoreyChange(type) {
				if (type == 'add') {
					this.addForm.elevatorStoreyList = this.addForm.elevatorStorey.split(",")
				} else {
					this.editForm.elevatorStoreyList = this.editForm.elevatorStorey.split(",")
				}
				
			}
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiElevatorQueryList()
		}
	};
</script>

<style scoped>
	
</style>
